import decode from 'jwt-decode';
import type { IdToken } from '~/contracts';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function getUserId(
  cookieValue: string | undefined = BrowserCookies.get('CVIdToken')
): string | undefined {
  if (!cookieValue) return undefined;

  try {
    const decodedToken = decode<IdToken>(cookieValue);
    const isExpired = decodedToken.exp * 1000 < Date.now();

    return isExpired ? undefined : decodedToken.user_id;
  } catch (e) {
    return undefined;
  }
}
